import React, { useState } from "react";
import {
  ServicesTabs,
  ServiceTab,
  ServicesContainer,
  ServicesCard,
} from "./Explore.styled";
import tenant from "../../assets/tenant.svg";
import landlord from "../../assets/landlord.svg";
import consultant from "../../assets/consultant.svg";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import General from '../../stores/GeneralStore'

const ExploreSection = () => {
  const [Tenant, setTenant] = useState("selected");
  const [Landlord, setLandlord] = useState("");
  const [Consultant, setConsultant] = useState("");

  const selectTenant = () => {
    setTenant("selected");
    setLandlord("");
    setConsultant("");
  };
  const selectLandlord = () => {
    setTenant("");
    setLandlord("selected");
    setConsultant("");
  };
  const selectConsultant = () => {
    setTenant("");
    setLandlord("");
    setConsultant("selected");
  };

  return (
    <>
      <h1 style={{ textAlign: "center", color: "#101e8e", width: "100%" }}>
        Explore Our Services
      </h1>
      <ServicesTabs>
        <ServiceTab className={Tenant} onClick={selectTenant}>
          <img src={tenant} alt="tenant" />
          <b>
          {General?.codeLabels["cm_services_iamtenant"]?.label
                      ? General?.codeLabels["cm_services_iamtenant"]?.label
                      : "I AM A TENANT"}
            {Tenant === "selected" && <div className="bottom-arrow"></div>}
          </b>
        </ServiceTab>
        <ServiceTab onClick={selectLandlord} className={Landlord}>
          <img src={landlord} alt="landlord" />
          <b>
          {General?.codeLabels["cm_services_lanlord"]?.label
                      ? General?.codeLabels["cm_services_lanlord"]?.label
                      : "I AM A LANDLORD"}
            {Landlord === "selected" && <div className="bottom-arrow"></div>}
          </b>
        </ServiceTab>
        <ServiceTab className={Consultant} onClick={selectConsultant}>
          <img src={consultant} alt="consultant" />
          <b>
          {General?.codeLabels["cm_services_consultant"]?.label
                      ? General?.codeLabels["cm_services_consultant"]?.label
                      : "I AM A CONSULTANT"}
            {Consultant === "selected" && <div className="bottom-arrow"></div>}
          </b>
        </ServiceTab>
      </ServicesTabs>
      <ServicesContainer>
        <ServicesCard>
          Pay Bill
          <NavigateNextIcon />
        </ServicesCard>
        <ServicesCard>
          Move In (Tenancy Registration)
          <NavigateNextIcon />
        </ServicesCard>
        <ServicesCard>
          Move Out (Service Termination)
          <NavigateNextIcon />
        </ServicesCard>
        <ServicesCard>
          Apply for NOC (For Tenants)
          <NavigateNextIcon />
        </ServicesCard>
        <ServicesCard>
          Request for Refund
          <NavigateNextIcon />
        </ServicesCard>
        <ServicesCard>
          Request for Payment Plan Facility
          <NavigateNextIcon />
        </ServicesCard>
        <ServicesCard>
          Request for Billing Details / History
          <NavigateNextIcon />
        </ServicesCard>
        <ServicesCard>
          Submit Forms
          <NavigateNextIcon />
        </ServicesCard>
      </ServicesContainer>
    </>
  );
};

export default ExploreSection;
